/**
Copyright (C) 2022 by SeQuenX  - All Rights Reserved
This file is part of the ComplyVantage product development,
and is released under the "Commercial License Agreement".
You should have received a copy of the Commercial License Agreement license with
this file. If not, please write to: legal@sequenx.com, or visit www.sequenx.com
*/
import React, { useState, forwardRef } from "react";
import { motion } from "framer-motion";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const TeamDetailsDialogs = (details) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  console.log(details);

  return (
    <div>
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={handleClickOpen}
        className="px-6 py-2 text-white border-2 border-white rounded-lg  hover:bg-white hover:text-gray-800 transition-colors duration-300"
      >
        View Details
      </motion.button>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "1rem",
            boxShadow:
              "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
          },
        }}
      >
        <div className="container mx-auto p-6">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.4 }}
              className="w-full md:w-1/3"
            >
              <img
                src={details?.details?.icon}
                alt={details?.details?.name}
                className="w-full rounded-lg shadow-lg"
              />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.4, delay: 0.2 }}
              className="w-full md:w-2/3"
            >
              <DialogTitle
                sx={{
                  fontFamily: "Alegreya Sans SC, sans-serif",
                  color: "#1a202c",
                  fontSize: "2rem",
                  fontWeight: "bold",
                  padding: 0,
                  marginBottom: "1rem",
                }}
              >
                {details?.details?.name}
              </DialogTitle>
              <DialogContent sx={{ padding: 0 }}>
                <DialogContentText
                  id="alert-dialog-slide-description"
                  sx={{
                    fontFamily: "Readex Pro, sans-serif",
                    color: "#4a5568",
                    fontSize: "1.1rem",
                    lineHeight: 1.7,
                  }}
                >
                  {details?.details?.description}
                </DialogContentText>
              </DialogContent>
            </motion.div>
          </div>
        </div>
        <DialogActions sx={{ padding: "1.5rem" }}>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleClose}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg  hover:bg-blue-700 transition-colors duration-300"
          >
            Close
          </motion.button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TeamDetailsDialogs;
